<!--
 * @FileDescription: 变化明细（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
            <div class="detail-top">
                <div class="detail-top-name">商品名称：{{formData.productName}}</div>
                <div class="detail-top-name" v-if="!isEmpty(formData.storageName)">所在仓库：{{formData.storageName}}</div>
                <a-range-picker   @change="onChangeData" />
            </div>
            <div class="line"></div>
            <a-table   class="detail-table"
                       :columns="columns"
                       :dataSource="dataSource"
                       :pagination="pagination"
                       @change="handleTableChange"
                       bordered
                       :scroll="{y:'calc(100vh - 405px)' }"
            >
            </a-table>
        </div>
    </div>
</template>
<script>
    import {conditionItem} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    export default {
        mixins:[mixins],
        data(){
            return{
                dataStart:'',
                dataEnd:'',
                columns:[
                    {
                        title: '序号',
                        dataIndex: '',
                        key: 'rowIndex',
                        width: 70,
                        align: 'center',
                        customRender(t, r, index) {
                            return parseInt(index) + 1
                        }
                    },
                    {
                        title: '单据日期',
                        dataIndex: 'voucherDate',
                        key: 'voucherDate',
                    },
                    {
                        title: '单据编号',
                        dataIndex: 'code',
                        key: 'code',
                    },
                    {
                        title: '入库量',
                        dataIndex: 'inboundCount',
                        key: 'inboundCount',
                        align:'right'
                    },
                    {
                        title: '出库量',
                        dataIndex: 'outboundCount',
                        key: 'outboundCount',
                        align:'right'
                    },
                ],
                dataSource:[],
                detailId:'',
                formData:{
                    productName:'',
                    storageName:'',
                    type:''
                },
            }
        },
        watch: {
            pageList(){
                if(!this.isEmpty(this.pageList.result)){
                    this.pagination.current = this.pageList.result.current
                    this.pagination.total = this.pageList.result.total
                    this.pagination.pageSize = this.pageList.result.size
                    this.pages = this.pageList.result.pages
                    this.dataSource = this.pageList.result.records
                }
            }
        },
        activated(){

        },
        mounted () {
            let item = decodeURIComponent(this.$route.query.item)
            this.detailId = JSON.parse(item).id
            this.formData.productName = JSON.parse(item).productName
            this.formData.storageName = JSON.parse(item).storageName
            this.formData.type = JSON.parse(item).type
            this.getList()
        },
        created () {

        },
        components: {


        },
        methods: {
            getList(){
                this.getPageList('/storage/api/inbound/pageListChangeDetailByCondition',
                        {    startTime:this.dataStart,
                            endTime:this.dataEnd,
                            type:this.formData.type,
                            productId:this.detailId,
                            pageNo:this.pagination.current,
                            pageSize:this.pagination.pageSize,
                        },{
                            'Content-Type':'application/json'
                        })
            },
            /**
             * @description: 时间改变（方法描述）
             */
            onChangeData(date, dateString) {
                this.dataStart = dateString[0]
                this.dataEnd = dateString[1]
                this.getList()
            },
            /**
             * @description: 表格页数切换（方法描述）
             */
            handleTableChange(pagination, filters, sorter){
                this.pagination.current = pagination.current
                this.pagination.pageSize = pagination.pageSize
                this.getList()
            },
        },

    }
</script>
<style lang="scss">
    .detail-top{
        .ant-calendar-picker{
            width: 250px !important;
        }
    }
    .detail-table{
        .ant-table{
            height: calc(100vh - 320px);
        }
        .ant-table-body{
            max-height: calc(100vh - 380px) !important;
        }
    }
</style>
<style scoped lang="scss">
.page-container-height{
    background-color: #fff;
    .detail-top{
        display: flex;
        height: 80px;
        align-items: center;
        padding-left: 30px;
        .detail-top-name{
            color: #333333;
            margin-right: 37px;
        }
    }
    .line{
        height: 16px;
        background-color: #F5F5F5;
    }
    .operator{
        color: #387BFC;
        cursor: pointer;
    }
}
</style>

